/**
 * Which companies are open in the list. Several can be open at once (no accordion). The set
 * survives navigation via sessionStorage, and a user-match search opens the matching companies
 * automatically unless the admin has explicitly collapsed one for the current query.
 */

const STORAGE_KEY = 'clients:expanded';

const emptyState = () => ({ manualExpanded: [], manualCollapsed: [], searchKey: '' });

export const loadExpandedState = () => {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return emptyState();
        const parsed = JSON.parse(raw);
        return {
            manualExpanded: Array.isArray(parsed.manualExpanded) ? parsed.manualExpanded : [],
            manualCollapsed: Array.isArray(parsed.manualCollapsed) ? parsed.manualCollapsed : [],
            searchKey: typeof parsed.searchKey === 'string' ? parsed.searchKey : '',
        };
    } catch {
        return emptyState();
    }
};

export const saveExpandedState = (state) => {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch {
        /* private mode / disabled storage — expansion just won't persist */
    }
};

/** A new search query clears the "explicitly collapsed" list so auto-expand works fresh. */
export const resetCollapsedOnSearchChange = (state, searchKey) =>
    state.searchKey === searchKey ? state : { ...state, manualCollapsed: [], searchKey };

export const isCompanyExpanded = (state, company) => {
    if (state.manualExpanded.includes(company.id)) return true;
    if (state.manualCollapsed.includes(company.id)) return false;
    return !!company.autoExpand;
};

export const toggleCompany = (state, company) => {
    const currentlyOpen = isCompanyExpanded(state, company);
    const without = (list) => list.filter((id) => id !== company.id);
    return currentlyOpen
        ? {
              ...state,
              manualExpanded: without(state.manualExpanded),
              manualCollapsed: [...without(state.manualCollapsed), company.id],
          }
        : {
              ...state,
              manualCollapsed: without(state.manualCollapsed),
              manualExpanded: [...without(state.manualExpanded), company.id],
          };
};
